'use client';

import React, { useState } from 'react';

import { IconName, Link } from '@bytel/trilogy-react';

import { EnergyLabelType } from '@app-types/product';

import { EnergyLabelModal } from '@components/product-details-modal';

type EnergyLabelProps = {
    energyLabel: EnergyLabelType;
};

export function EnergyLabel({ energyLabel }: Readonly<EnergyLabelProps>) {
    const [isEnergyLabelModalOpen, setIsEnergyLabelModalOpen] = useState(false);

    return (
        <>
            <button
                onClick={() => setIsEnergyLabelModalOpen(true)}
                className='button-clear w-fit'
                aria-label="Voir l'étiquette énergétique"
            >
                <img src={energyLabel.img} alt={energyLabel.label} width={150} height={300} loading='lazy' />
            </button>
            <Link href={energyLabel.pdf} blank iconName={IconName.NEW_TABBED_PAGE}>
                Voir la fiche d&apos;information du produit
            </Link>
            {isEnergyLabelModalOpen && (
                <EnergyLabelModal onClose={() => setIsEnergyLabelModalOpen(false)} energyLabel={energyLabel} />
            )}
        </>
    );
}
